<script>
	import { Router, Route } from "svelte-routing";
	import MainCarparkManagement from "./Manage/MainCarparkManagement.svelte";
	import CarparkDetail from "./CarparkDetail/CarparkDetail.svelte";
	import CreateCarparkForm from "./CreateCarparkForm.svelte";
	import EditDetail from "./CarparkDetail/EditDetail.svelte";
	import CreateLotForm from "./CarparkDetail/CreateLotForm.svelte";
	import EditLotForm from "./CarparkDetail/EditLotForm.svelte";
</script>

<Router url="/">
	<Route path="/" component={MainCarparkManagement} />
	<Route path="/create" component={CreateCarparkForm} />
	<Route path="/details/:carParkId" let:params>
		<CarparkDetail carParkId={params.carParkId} />
	</Route>
	<Route path="/details/edit/:carParkId" let:params>
		<EditDetail carParkId={params.carParkId} />
	</Route>
	<Route path="/details/add-lot/:carParkId" let:params>
		<CreateLotForm carParkId={params.carParkId} />
	</Route>
	<Route path="/details/edit-lot/:id/:carParkId" let:params>
		<EditLotForm isEdit={params.id} carParkId={params.carParkId} />
	</Route>
</Router>
